import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from 'wouter';
import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import Swal from 'sweetalert2';
import ListBox from './list_box';
import { getLivelli, bulkCreateEmployees } from '../services/api';
// import '../styles/fireworks.css';


const shiftTypes = [
  { name: 'Fisso', value: 'fisso' },
  { name: 'Turno', value: 'turno' },
  { name: 'A Chiamata', value: 'a_chiamata' },
  { name: 'Senza Calendario', value: 'senza_calendario' }
];

const getContractTypeLabel = (value) => {
  const found = shiftTypes.find(opt => opt.value === value);
  return found ? found.name : '';
};


export default function OnBoarding({ token, onComplete, isFirstOpen, addingEmployees }) {
  // State to track if this is the first visit
  const [isFirstVisit, setIsFirstVisit] = useState(false);
  const [availableEmployees, setAvailableEmployees] = useState();
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState([]);


  
  // Check if this is the first visit when component mounts
  useEffect(() => {
    const hasVisitedOnboarding = localStorage.getItem('hasVisitedOnboarding');
    if (!hasVisitedOnboarding) {
      setIsFirstVisit(true);
      localStorage.setItem('hasVisitedOnboarding', 'true');
    }
  }, []);

  const buttonLabel = isFirstOpen
  ? 'Vai alla dashboard'
  : addingEmployees
  ? 'Torna al form precedente'
  : 'Torna alla dashboard';


  // Effetto per aggiungere coriandoli personalizzati
  // useEffect(() => {
  //   let timerId = null;

  //   if (isFirstVisit && confettiContainerRef.current) {
  //     const container = confettiContainerRef.current;
  //     const confettiCount = 120; // Reduced slightly for the new effect
  //     const colors = ['#f94144', '#f3722c', '#f8961e', '#f9c74f', '#90be6d', '#43aa8b', '#577590'];

  //     const createConfetti = () => {
  //       // Clear container
  //       while (container.firstChild) {
  //         container.removeChild(container.firstChild);
  //       }

  //       // Create cannon sources at the bottom
  //       const cannonPositions = [
  //         Math.random() * 15 + 15, // Left cannon (15-30%)
  //         Math.random() * 15 + 42.5, // Center cannon (42.5-57.5%)
  //         Math.random() * 15 + 70  // Right cannon (70-85%)
  //       ];

  //       for (let i = 0; i < confettiCount; i++) {
  //         const confetti = document.createElement('div');
  //         confetti.classList.add('confetti');

  //         // Random color
  //         const color = colors[Math.floor(Math.random() * colors.length)];
  //         confetti.style.backgroundColor = color;

  //         // Random rectangular sizes
  //         // Create a mix of horizontal and vertical rectangles
  //         const isHorizontal = Math.random() > 0.5;
  //         const width = isHorizontal ? Math.random() * 12 + 8 : Math.random() * 5 + 5; // 8-20px or 5-10px
  //         const height = isHorizontal ? Math.random() * 5 + 3 : Math.random() * 12 + 6; // 3-8px or 6-18px
          
  //         confetti.style.width = `${width}px`;
  //         confetti.style.height = `${height}px`;

  //         // Initial position - from one of the cannons
  //         const cannonIndex = Math.floor(Math.random() * cannonPositions.length);
  //         const initialPosition = cannonPositions[cannonIndex];
  //         confetti.style.setProperty('--start-x', `${initialPosition}vw`);
          
  //         // Random shooting angle between -30 and +30 degrees
  //         // Convert to horizontal offset based on the trajectory height
  //         const angle = Math.random() * 60 - 30; // -30 to +30 degrees
  //         const maxHeight = Math.random() * 30 + 30; // 30-60vh height
          
  //         // Calculate horizontal offset based on angle and height
  //         // Using a simplified version: tan(angle) * height
  //         const angleInRadians = angle * (Math.PI / 180);
  //         const horizontalOffset = Math.tan(angleInRadians) * maxHeight;
  //         const scaledOffset = horizontalOffset * 1.5; // Adjust scale for better visual
          
  //         confetti.style.setProperty('--angle-offset', `${scaledOffset}vw`);
  //         confetti.style.setProperty('--max-height', `${maxHeight}vh`);
          
  //         // Animation timing
  //         const animDuration = Math.random() * 2 + 3; // 3-5s for the shoot-up animation
  //         const spinDuration = Math.random() * 1 + 2; // 2-3s for the spin
  //         const animDelay = Math.random() * 2; // Delay up to 2s
          
  //         confetti.style.animationDuration = `${animDuration}s, ${spinDuration}s`;
  //         confetti.style.animationDelay = `${animDelay}s, ${animDelay}s`;
          
  //         // Additional random drift (minor adjustment)
  //         const xDrift = (Math.random() - 0.5) * 15; // Reduced since we have angle now
  //         confetti.style.setProperty('--x-drift', `${xDrift}vw`);
          
  //         container.appendChild(confetti);
  //       }
  //     };

  //     createConfetti();

  //     // Create a second batch after a short delay for continuous effect
  //     setTimeout(() => {
  //       if (container) createConfetti();
  //     }, 1500);

  //     // Create a third batch for fuller effect
  //     setTimeout(() => {
  //       if (container) createConfetti();
  //     }, 3000);

  //     // Remove confetti after 15 seconds
  //     timerId = setTimeout(() => {
  //       if (container) {
  //         while (container.firstChild) {
  //           container.removeChild(container.firstChild);
  //         }
  //       }
  //     }, 15000);

  //     return () => {
  //       if (timerId) {
  //         clearTimeout(timerId);
  //       }
  //       if (container) {
  //         while (container.firstChild) {
  //           container.removeChild(container.firstChild);
  //         }
  //       }
  //     };
  //   }
  // }, [isFirstVisit]);

  // Stato iniziale per un singolo dipendente
  const initialFormState = {
    nome: '',
    cognome: '',
    codiceFiscale: '',
    dataContratto: '',
    dataFineContratto: '',
    tipoTurno: '',
    ore: '',
    email: '',
    appAttiva: false
  };
  
  // Array di dipendenti
  const [employees, setEmployees] = useState([initialFormState]);
  
  // Indice del dipendente attualmente selezionato
  const [currentIndex, setCurrentIndex] = useState(0);
  
  // Stato per tenere traccia del nuovo dipendente aggiunto
  const [newEmployeeIndex, setNewEmployeeIndex] = useState(null);
  
  // Riferimento all'elemento del tab
  const tabsRef = useRef([]);


  const fetchLivelli = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getLivelli(token);
      setAvailableEmployees(data.available_employees);
    } catch (err) {
      setError('Impossibile recuperare i livelli');
      Swal.fire({
        title: 'Errore',
        text: 'Impossibile recuperare i livelli.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    } finally {
      setLoading(false);
    }
  }, [token]);
    
  useEffect(() => {
      if (token) {
        fetchLivelli();
      }
  }, [token]);

  const handleChange = (e, index) => {
    const { name, value, type, checked } = e.target;
  
    const newValue = type === 'checkbox' ? checked : value;
  
    // Aggiorna valore del dipendente
    const updatedEmployees = [...employees];
    updatedEmployees[index] = {
      ...updatedEmployees[index],
      [name]: newValue,
    };
    setEmployees(updatedEmployees);
  
    // Rimuovi eventuale errore su quel campo dopo un submit
    if (hasSubmitted) {
      const updatedErrors = [...errors];
      if (updatedErrors[index]) {
        // Rimuovi errore dal campo
        delete updatedErrors[index][name];
    
        // Se non ci sono più errori per questo dipendente, rimuovi l'intero oggetto
        if (Object.keys(updatedErrors[index]).length === 0) {
          updatedErrors[index] = undefined;
        }
      }
      setErrors(updatedErrors);
    }
  };  
  
  // Aggiunge un nuovo form per dipendente
  const addEmployee = () => {
    setEmployees([...employees, {...initialFormState}]);
    setErrors([...errors, {}]);
    const newIndex = employees.length;
    setCurrentIndex(newIndex); // Seleziona il nuovo dipendente
    setNewEmployeeIndex(newIndex); // Imposta l'indice del nuovo dipendente per l'animazione
  };
  
  // Effetto per gestire l'animazione del nuovo tab
  useEffect(() => {
    if (newEmployeeIndex !== null) {
      // Timeout per rimuovere l'effetto dopo 2 secondi
      const timer = setTimeout(() => {
        setNewEmployeeIndex(null);
      }, 2000);
      
      return () => clearTimeout(timer);
    }
  }, [newEmployeeIndex]);
  
  // Rimuove un dipendente dall'array
  const removeEmployee = (index) => {
    if (employees.length > 1) {
      const updatedEmployees = employees.filter((_, i) => i !== index);
      const updatedErrors = errors.filter((_, i) => i !== index);
      setEmployees(updatedEmployees);
      
      // Aggiorna l'indice corrente se necessario
      if (currentIndex >= updatedEmployees.length) {
        setCurrentIndex(updatedEmployees.length - 1);
      } else if (currentIndex === index) {
        setCurrentIndex(Math.max(0, index - 1));
      }
    }
  };
  
  function isValidFourDigitYear(dateString) {
    const match = dateString?.match(/^(\d{4})-\d{2}-\d{2}$/);
    if (!match) return false;
    const year = parseInt(match[1], 10);
    return year >= 1900 && year <= 2999;
  }
  
  function validateEmployee(employee, allEmployees, index) {
    const errors = {};
    
    if (!employee.nome) errors.nome = 'Il nome è obbligatorio';
    if (!employee.cognome) errors.cognome = 'Il cognome è obbligatorio';
  
    if (!employee.codiceFiscale) {
      errors.codiceFiscale = 'Il codice fiscale è obbligatorio';
    } else {
      const cf = employee.codiceFiscale.trim();
      if (cf) {
        const duplicateIndex = allEmployees.findIndex((e, i) =>
          i !== index && e.codiceFiscale?.trim() === cf
        );
        if (duplicateIndex !== -1) {
          errors.codiceFiscale = `Codice fiscale già inserito nel dipendente ${duplicateIndex + 1}`;
        }
      }
    }

    if (!employee.dataContratto) {
      errors.dataContratto = 'La data di inizio contratto è obbligatoria';
    }
    
    if (employee.dataContratto && employee.dataFineContratto) {
      const startDate = new Date(employee.dataContratto);
      const endDate = new Date(employee.dataFineContratto);
    
      if (endDate < startDate) {
        errors.dataFineContratto = 'La data di fine contratto non può essere precedente alla data di inizio';
      }
    }

    if (!employee.dataContratto) {
      errors.dataContratto = 'La data di inizio contratto è obbligatoria';
    } else if (!isValidFourDigitYear(employee.dataContratto)) {
      errors.dataContratto = 'La data di inizio contratto non è valida (anno a 4 cifre richiesto)';
    }
    
    if (employee.dataFineContratto && !isValidFourDigitYear(employee.dataFineContratto)) {
      errors.dataFineContratto = 'La data di fine contratto non è valida (anno a 4 cifre richiesto)';
    }

    if (!employee.tipoTurno) {
      errors.tipoTurno = 'La tipologia di turno è obbligatoria';
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (employee.email && !emailRegex.test(employee.email)) {
      errors.email = 'Inserisci un’email valida';
    }

 
    const email = employee.email.trim();
    if (email) {
      const duplicateIndex = allEmployees.findIndex((e, i) =>
        i !== index && e.email?.trim() === email
      );
      if (duplicateIndex !== -1) {
        errors.email = `Indirizzo email già inserito nel dipendente ${duplicateIndex + 1}`;
      }
    }

    if (employee.appAttiva) {
      if (!employee.email) {
        errors.appAttiva = 'Per abilitare l\'accesso all\'app è necessario inserire un’email';
      } else if (!emailRegex.test(employee.email)) {
        errors.appAttiva = 'L’email inserita non è valida per l\'accesso all\'app';
      }
    }
  
    return errors;
  }

  const flattenErrors = (errors, prefix = '') => {
    let messages = [];
  
    if (Array.isArray(errors)) {
      errors.forEach((item, index) => {
        messages.push(...flattenErrors(item, `${prefix}[${index}]`));
      });
    } else if (typeof errors === 'object' && errors !== null) {
      Object.entries(errors).forEach(([key, value]) => {
        messages.push(...flattenErrors(value, prefix ? `${prefix}.${key}` : key));
      });
    } else {
      messages.push(`${prefix}: ${errors}`);
    }
  
    return messages;
  };

  const formatDate = (date) => {
    if (!date) return null;
    if (typeof date === 'string') return date;
    return date.toISOString().split('T')[0];
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
  
    setHasSubmitted(true);
  
    const validationResults = employees.map((emp, index) =>
      validateEmployee(emp, employees, index)
    );
    setErrors(validationResults);

    const hasErrors = validationResults.some(err => Object.keys(err).length > 0);
    if (hasErrors) {
      Swal.fire({
        icon: 'error',
        title: 'Errore',
        text: 'Controlla i dati inseriti: ci sono errori nei form.',
      });
      return;
    }
   
    const payload = {
      employees: employees.map(emp => ({
        first_name: emp.nome,
        last_name: emp.cognome,
        email_auth: emp.email,
        cf: emp.codiceFiscale,
        app_activate: emp.appAttiva,
        contract: {
          start_date: formatDate(emp.dataContratto),
          end_date: formatDate(emp.dataFineContratto),
          shift_type: emp.tipoTurno,
          week_hours: emp.ore !== '' ? emp.ore.toString() : null,
        }
      }))
    };
    
    try {
      await bulkCreateEmployees(token, payload);
  
      Swal.fire({
        icon: 'success',
        title: 'Dipendenti salvati',
        text: `${employees.length} dipendenti sono stati aggiunti con successo!`,
        confirmButtonText: 'Continua'
      }).then(() => {
        if (onComplete) onComplete();
      });
  
    } catch (error) {
      console.error('Errore durante la creazione dei dipendenti:', error);
      let errorMessage = 'Non è stato possibile creare i dipendenti. Per favore riprova.';
    
      if (error.response && error.response.data) {
        const flatErrors = flattenErrors(error.response.data);
        if (flatErrors.length > 0) {
          errorMessage = flatErrors.join('\n');
        }
      }
    
      Swal.fire({
        icon: 'error',
        title: 'Errore',
        text: errorMessage,
        confirmButtonText: 'OK',
      });
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        {isFirstOpen ? (
          <div className="text-center mb-12">
            <h1 className="text-4xl font-extrabold text-indigo-700 mt-8 mb-3">Benvenuto!</h1>
            <p className="text-xl text-gray-600">
              Per iniziare con Consultala HR aggiungi subito i dipendenti della tua azienda<br />
              in modo facile e veloce!
            </p>
            <h2 className="text-4xl font-extrabold text-indigo-700 mt-8 mb-3">Aggiungi i tuoi dipendenti</h2>
            <p className="text-xl text-gray-600">
              Inserisci i dati dei tuoi dipendenti e sarai subito pronto per utilizzare tutte le funzionalità di Consultala HR.
            </p>
            {availableEmployees && (
              <p className='text-xl text-gray-600'>Hai a disposizione {availableEmployees} dipendenti attivabili!</p>
            )}
          </div>
        ) : (
          <div className="text-center mb-12">
            <h2 className="text-4xl font-extrabold text-indigo-700 mt-8 mb-3">Aggiungi i tuoi dipendenti</h2>
          </div>
        )}

        {/* Form */}
        <div className="max-w-5xl mx-auto bg-white rounded-lg shadow-md overflow-hidden mb-8 border border-indigo-200">
          <div className="p-6 border-b border-indigo-200">
            {/* Tabs per navigare tra i dipendenti */}
            <div className="flex flex-wrap mb-4 gap-2">
              {employees.map((employee, index) => (
                <button
                  key={index}
                  ref={el => tabsRef.current[index] = el}
                  type="button"
                  onClick={() => setCurrentIndex(index)}
                  className={`px-3 py-1 text-sm rounded-full transition-all duration-300 ${
                    currentIndex === index
                      ? 'bg-indigo-600 text-white'
                      : errors[index] && Object.keys(errors[index]).length > 0
                        ? 'bg-red-200 text-red-700 ring-1 ring-red-400'
                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                  } ${
                    newEmployeeIndex === index
                      ? 'animate-pulse shadow-lg shadow-indigo-300 scale-110'
                      : ''
                  }`}
                >
                  {(employee.nome || employee.cognome)
                    ? `${index + 1}. ${(employee.cognome ?? '')} ${(employee.nome ?? '')}`.trim()
                    : `Dipendente ${index + 1}`
                  }
                </button>
              ))}
            </div>
            
            <form>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                <div>
                  <label htmlFor="cognome" className="block text-sm font-medium text-gray-700 mb-1">Cognome *</label>
                  <input
                    type="text"
                    id="cognome"
                    name="cognome"
                    value={employees[currentIndex].cognome}
                    onChange={(e) => handleChange(e, currentIndex)}
                    placeholder="Inserisci cognome"
                    className="w-full p-2 border border-indigo-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    required
                  />
                  {hasSubmitted && errors[currentIndex]?.cognome  && (
                    <p className="text-red-500 text-sm mt-1">{errors[currentIndex].cognome}</p>
                  )}
                </div>
                <div>
                  <label htmlFor="nome" className="block text-sm font-medium text-gray-700 mb-1">Nome *</label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    value={employees[currentIndex].nome}
                    onChange={(e) => handleChange(e, currentIndex)}
                    placeholder="Inserisci nome"
                    className="w-full p-2 border border-indigo-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    required
                  />
                  {hasSubmitted && errors[currentIndex]?.nome && (
                    <p className="text-red-500 text-sm mt-1">{errors[currentIndex].nome}</p>
                  )}
                </div>
                <div>
                  <label htmlFor="codiceFiscale" className="block text-sm font-medium text-gray-700 mb-1">Codice Fiscale *</label>
                  <input
                    type="text"
                    id="codiceFiscale"
                    name="codiceFiscale"
                    value={employees[currentIndex].codiceFiscale}
                    onChange={(e) => handleChange(e, currentIndex)}
                    placeholder="Inserisci codice fiscale"
                    className="w-full p-2 border border-indigo-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    required
                  />
                  {hasSubmitted && errors[currentIndex]?.codiceFiscale && (
                    <p className="text-red-500 text-sm mt-1">{errors[currentIndex].codiceFiscale}</p>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                <div>
                  <label htmlFor="dataContratto" className="block text-sm font-medium text-gray-700 mb-1">Data inizio contratto *</label>
                  <input
                    type="date"
                    id="dataContratto"
                    name="dataContratto"
                    value={employees[currentIndex].dataContratto}
                    onChange={(e) => handleChange(e, currentIndex)}
                    className="w-full p-2 border border-indigo-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    required
                  />
                  {hasSubmitted && errors[currentIndex]?.dataContratto && (
                    <p className="text-red-500 text-sm mt-1">{errors[currentIndex].dataContratto}</p>
                  )}
                </div>
                <div>
                  <label htmlFor="dataFineContratto" className="block text-sm font-medium text-gray-700 mb-1">Data fine contratto</label>
                  <input
                    type="date"
                    id="dataFineContratto"
                    name="dataFineContratto"
                    value={employees[currentIndex].dataFineContratto}
                    onChange={(e) => handleChange(e, currentIndex)}
                    className="w-full p-2 border border-indigo-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  />
                  {hasSubmitted && errors[currentIndex]?.dataFineContratto && (
                    <p className="text-red-500 text-sm mt-1">{errors[currentIndex].dataFineContratto}</p>
                  )}
                </div>
                <div>
                  <label htmlFor="tipoTurno" className="block text-sm font-medium text-gray-700 mb-1">
                    Tipologia turno *
                  </label>
                  <ListBox
                    key={`tipoTurno-${currentIndex}`}
                    options={shiftTypes}
                    wrapperClassName="border border-indigo-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    defaultValue={
                      employees[currentIndex]?.tipoTurno
                        ? { name: getContractTypeLabel(employees[currentIndex].tipoTurno), value: employees[currentIndex].tipoTurno }
                        : undefined
                    }
                    onChange={(selectedOption) => {
                      handleChange(
                        { target: { name: 'tipoTurno', value: selectedOption.value } },
                        currentIndex
                      );
                    }}
                    required
                  />
                  {hasSubmitted && errors[currentIndex]?.tipoTurno && (
                    <p className="text-red-500 text-sm mt-1">{errors[currentIndex].tipoTurno}</p>
                  )}
                </div>
                <div>
                  <label htmlFor="ore" className="block text-sm font-medium text-gray-700 mb-1">Ore settimanali</label>
                  <input
                    type="number"
                    id="ore"
                    name="ore"
                    value={employees[currentIndex].ore}
                    onChange={(e) => handleChange(e, currentIndex)}
                    placeholder="Ore (se contratto fisso o turno)"
                    className="w-full p-2 border border-indigo-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    min="0"
                  />
                  {hasSubmitted && errors[currentIndex]?.ore && (
                    <p className="text-red-500 text-sm mt-1">{errors[currentIndex].ore}</p>
                  )}
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email dipendente</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={employees[currentIndex].email}
                    onChange={(e) => handleChange(e, currentIndex)}
                    placeholder="Inserisci email"
                    className="w-full p-2 border border-indigo-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    required
                  />
                  {hasSubmitted && errors[currentIndex]?.email && (
                    <p className="text-red-500 text-sm mt-1">{errors[currentIndex].email}</p>
                  )}
                </div>
                <div className="flex flex-col justify-center">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Accesso app</label>
                  <div className="flex items-center">
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        name="appAttiva"
                        checked={employees[currentIndex].appAttiva}
                        onChange={(e) => handleChange(e, currentIndex)}
                        className="form-checkbox h-5 w-5 text-indigo-600"
                      />
                      <span className="ml-2 text-gray-700">App attiva</span>
                    </label>
                  </div>
                  {hasSubmitted && errors[currentIndex]?.appAttiva && (
                    <p className="text-red-500 text-sm mt-1">{errors[currentIndex].appAttiva}</p>
                  )}
                </div>
              </div>

              {/* Pulsante per rimuovere il dipendente corrente */}
              {employees.length > 1 && (
                <div className="flex justify-end mt-4">
                  <button
                    type="button"
                    onClick={() => removeEmployee(currentIndex)}
                    className="flex items-center px-3 py-1 text-sm bg-red-100 text-red-700 rounded-md hover:bg-red-200"
                  >
                    <TrashIcon className="h-4 w-4 mr-1" />
                    Rimuovi dipendente
                  </button>
                </div>
              )}
            </form>
          </div>

          {/* Area per aggiungere più dipendenti */}
          <div 
            className="p-6 bg-indigo-50 flex items-center justify-center min-h-[150px] cursor-pointer hover:bg-indigo-100 transition-colors"
            onClick={addEmployee}
          >
            <div className="text-center">
              <PlusIcon className="h-12 w-12 text-indigo-500 mx-auto mb-2" />
              <p className="text-gray-600">Clicca qui per aggiungere un nuovo dipendente</p>
            </div>
          </div>
        </div>

        {/* Pulsante SALVA TUTTI spostato fuori dal form */}
        <div className="flex justify-center mb-8">
          <button
            onClick={handleSubmit}
            className="px-8 py-3 bg-indigo-600 text-white font-semibold rounded-full hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 uppercase shadow-md"
          >
            SALVA TUTTI ({employees.length} dipendenti)
          </button>
        </div>
        
        {/* Link per saltare l'onboarding */}
        {/* <div className="text-center">
          <Link href="/">
            <a className="text-indigo-600 hover:text-indigo-800 font-medium">Salta e vai alla dashboard</a>
          </Link>
        </div> */}
        <div className='text-center'>
          <button
            onClick={() => onComplete(true)}
            className="text-indigo-600 hover:text-indigo-800 font-medium"
          >
            {buttonLabel}
          </button>
        </div>
      </div>
      
      {/* Fireworks effect that only shows on first visit */}
      {/* {isFirstVisit && (
        <div className="fireworks-container">
          <div className="firework">
            {[...Array(12)].map((_, i) => (
              <div key={i} className="particle"></div>
            ))}
          </div>
          <div className="firework">
            {[...Array(12)].map((_, i) => (
              <div key={i} className="particle"></div>
            ))}
          </div>
          <div className="firework">
            {[...Array(12)].map((_, i) => (
              <div key={i} className="particle"></div>
            ))}
          </div>
          <div className="firework">
            {[...Array(12)].map((_, i) => (
              <div key={i} className="particle"></div>
            ))}
          </div>
          <div className="firework">
            {[...Array(12)].map((_, i) => (
              <div key={i} className="particle"></div>
            ))}
          </div>
        </div>
      )} */}
    </div>
  );
}

